'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Offers = void 0;
var transport_1 = require("../../transport");
var Offers = /** @class */ (function () {
    function Offers() {
    }
    Offers.prototype.get = function (params) {
        return transport_1.transport.request('offers/get', params);
    };
    Offers.prototype.getAll = function (params) {
        return transport_1.transport.request('offers/get', params);
    };
    Offers.prototype.optIn = function (params) {
        return transport_1.transport.request('offers/optIn', params);
    };
    return Offers;
}());
exports.Offers = Offers;
